import { Button, ButtonGroup, styled } from '@mui/material';
import { MIN_DRAWER_HEIGHT } from '../../../../components/Drawer/tab-drawer/TabDrawer.constants';

// Styled components
export const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  '& .MuiButtonGroup-groupedHorizontal': {
    borderColor: theme.palette.primary.light,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiButtonGroup-middleButton': {
    borderTopRightRadius: '2.688rem',
    borderBottomRightRadius: '2.688rem',
  },
  '& .MuiButtonGroup-lastButton': {
    borderTopLeftRadius: '2.688rem',
    borderBottomLeftRadius: '2.688rem',
  },
  borderRadius: '2.688rem',
  marginTop: '1.5em',
  position: 'fixed',
  right: '2rem',
  bottom: '2rem',
  zIndex: 150,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  width: 'fit-content',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const ProjectedButton = styled(StyledButton)({
  borderBottomLeftRadius: '2.688rem',
  borderTopLeftRadius: '2.688rem',
  marginBottom: MIN_DRAWER_HEIGHT,
});

export const DropdownButton = styled(StyledButton)({
  borderBottomRightRadius: '2.688rem',
  borderTopRightRadius: '2.688rem',
  borderTopLeftRadius: '0 !important',
  borderBottomLeftRadius: '0 !important',
  marginBottom: MIN_DRAWER_HEIGHT,
});

export const HistoricalButton = styled(StyledButton)({
  position: 'fixed',
  right: '2rem',
  bottom: '7rem',
  borderRadius: 'inherit',
});
